import { saveAs } from 'file-saver';
import moment from 'moment-timezone';
import { ConversationType, MessageType } from '../constants/values';
export const convertToMinutes = (seconds) => {
  const format = (val) => `0${Math.floor(val)}`.slice(-2);
  const hours = seconds / 3600;
  const minutes = (seconds % 3600) / 60;
  return [hours, minutes, seconds % 60].map(format).join(':');
};

export const momentCustom = (isUTC = false, timezone = 'America/New_York') => {
  // Setting default timezone
  if (timezone) moment.tz.setDefault(timezone);

  return isUTC ? moment.utc : moment;
};

export const momentCustomInstance = (...arg) => momentCustom()(...arg);

export const formatDateTime = (dateTime, isCustomFormat = true, isWithTz = false, isUTC = false, timezone = 'America/New_York', dateFormat = 'DD MMMM YYYY', timeFormat = 'hh:mm A') => {
  if (!dateTime) return 'N/A';

  const tzFormat = 'z';
  let formatedDate = '';

  const momentInstance = momentCustom(isUTC, timezone);
  const now = momentInstance();
  const dateToFormat = momentInstance(dateTime);

  // Setting limits
  const DAYS_LIMIT = 3;
  const HOURS_LIMIT = 3;

  // Difference in days
  const daysDiff = now.diff(dateToFormat, 'days');
  // Difference in hours
  const hoursDiff = now.diff(dateToFormat, 'hours');
  // Same day check
  const isSameDay = now.isSame(dateToFormat, 'day');

  if (!isCustomFormat || daysDiff > DAYS_LIMIT) {
    formatedDate = momentInstance(dateTime).format(`${dateFormat} ${timeFormat} ${isWithTz ? tzFormat : ''}`);
  } else if (!isSameDay && daysDiff < 1) {
    formatedDate = 'a day ago';
  } else if ((hoursDiff > 24 && daysDiff <= DAYS_LIMIT) || (!isSameDay && daysDiff <= DAYS_LIMIT)) {
    formatedDate = momentInstance(dateTime).fromNow();
  } else if (hoursDiff >= HOURS_LIMIT) {
    formatedDate = momentInstance(dateTime).format(`${timeFormat} ${isWithTz ? tzFormat : ''}`);
  } else {
    formatedDate = momentInstance(dateTime).fromNow();
  }

  return formatedDate;
};

/*
 *
 * @param {*} data    Array of hour and per hour count
 * @returns           evenHoursData
 */
export const getEvenHoursData = (data) => {
  if (!data || data.length === 0) return [];

  // Data of even hours
  const evenHoursData = [];
  // Index where to merge data
  let head = 0;

  data.forEach((element, index) => {
    if (element.hour % 2 === 0) {
      // Push data for first hour
      evenHoursData.push({ ...element, hour: element.hour + 2 });
      // Set head when next merge needed
      head = index / 2;
    } else if (evenHoursData[head].hour === element.hour + 1) {
      // Set label for charts labels
      evenHoursData[head].label = (evenHoursData[head].hour % 12 || 12) + (evenHoursData[head].hour >= 12 ? ` PM` : ` AM`);
      evenHoursData[head].perHourCount += element.perHourCount;
    }
  });

  // Check if 24th hour exist bring it to first index
  const lastHour = evenHoursData[evenHoursData.length - 1];
  if (lastHour && lastHour.hour === 24) {
    lastHour.hour = 12;
    lastHour.label = '12 AM';
    evenHoursData.unshift(evenHoursData.pop());
  }

  return evenHoursData;
};

/*
 *
 * @param {*} data    Array of hour and per hour count
 * @returns           Hours data with even labels
 */
export const getHoursDataWithLabels = (data) => {
  if (!data || data.length === 0) return [];

  // Data of hours
  const hoursData = [];

  data.forEach((element, index) => {
    const hour = element.hour + 1;
    hoursData.push({
      ...element,
      hour,
      label: (hour % 12 || 12) + (hour >= 12 ? ` PM` : ` AM`),
    });
  });

  // Check if 24th hour exist bring it to first index
  const lastHour = hoursData[hoursData.length - 1];
  if (lastHour && lastHour.hour === 24) {
    lastHour.hour = 12;
    lastHour.label = '12 AM';
    hoursData.unshift(hoursData.pop());
  }

  return hoursData;
};

export const getLanguageWord = (key, value) => {
  return key ? key : value;
};

export const FormattedEmail = (str, isFromChat) => {
  let formattedEmail = str.replace(/\./g, '');
  formattedEmail = formattedEmail.replace(/\@/g, '');
  if (!isFromChat) {
    formattedEmail = formattedEmail.replace(/\-/g, '');
  }
  return formattedEmail;
};
export function printConsoleLog(logMsg, ...args) {
  let date = new Date().toLocaleString();
  console.log(date + ' :: ' + logMsg);
  for (let i = 0; i < args.length; i++) {
    console.log(args[i]);
  }
}
export function sort(items) {
  items.sort((a, b) => {
    if (!a.lastMessage) {
      return 1;
    } else if (!a.lastMessage.dateCreated) {
      return 1;
    }
    if (!b.lastMessage) {
      return -1;
    } else if (!b.lastMessage.dateCreated) {
      return -1;
    }
    const dateA = new Date(a.lastMessage.dateCreated);
    const dateB = new Date(b.lastMessage.dateCreated);
    return dateA < dateB ? 1 : -1;
  });
}

export const composeMessage = (message, fromTwilio, userName, conversationType, agentName, chatUserId) => {
  let direction = '';
  if (!fromTwilio) {
    if (conversationType == ConversationType.Agent) {
      if (userName == message.author) {
        direction = 'outgoing';
      } else {
        direction = FormattedEmail(message.author.toLowerCase(), true) == userName ? 'outgoing' : 'incoming';
      }
    } else {
      direction = FormattedEmail(message.author.toLowerCase(), true) == userName ? 'outgoing' : 'incoming';
    }
    return {
      sid: message.sid,
      username: agentName,
      date: moment(message.dateUpdated).calendar(),
      body: message.body,
      index: message.index,
      incoming: direction == 'incoming' ? true : false,
      direction,
      deliveryReceipt: message.deliveryReceipt,
      datetime: new Date(message.dateUpdated),
      media: message.medias ? message.medias.map((x) => x.state) : null,
    };
  } else {
    if (conversationType == ConversationType.Agent) {
      if (message.sender.userId == chatUserId) {
        direction = 'outgoing';
      } else {
        direction = 'incoming';
      }
    } else {
      if (message.sender.type == MessageType.Customer && message.body && message.body.includes("We're not around")) {
        direction = 'outgoing';
      } else {
        direction = message.sender.type == MessageType.Customer ? 'incoming' : 'outgoing';
      }
    }
  }
  return {
    sid: message.sid,
    username: message.sender.name,
    date: moment(message.dateUpdated).calendar(),
    body: message.body,
    index: message.index,
    deliveryReceipt: message.deliveryReceipt,
    datetime: new Date(message.dateUpdated),
    incoming: direction == 'incoming' ? true : false,
    media: message.media,
    direction,
  };
};

export const composeFacebookMessage = (message, fromTwilio, userName, conversationType, agentName, chatUserId, medias) => {
  let direction = '';
  let fbMedia = [];
  medias.forEach((item, index) => {
    fbMedia.push({ filename: item.fileName, size: item.size });
  });
  if (!fromTwilio) {
    if (conversationType == ConversationType.Agent) {
      if (userName == message.author) {
        direction = 'outgoing';
      } else {
        direction = FormattedEmail(message.author.toLowerCase(), true) == userName ? 'outgoing' : 'incoming';
      }
    } else {
      direction = FormattedEmail(message.author.toLowerCase(), true) == userName ? 'outgoing' : 'incoming';
    }
    return {
      sid: message.sid,
      username: agentName,
      date: moment(message.dateUpdated).calendar(),
      body: message.body,
      index: message.index,
      incoming: direction == 'incoming' ? true : false,
      direction,
      deliveryReceipt: message.deliveryReceipt,
      datetime: new Date(message.dateUpdated),
      media: fbMedia,
    };
  } else {
    if (conversationType == ConversationType.Agent) {
      if (message.sender.userId == chatUserId) {
        direction = 'outgoing';
      } else {
        direction = 'incoming';
      }
    } else {
      if (message.sender.type == MessageType.Customer && message.body && message.body.includes("We're not around")) {
        direction = 'outgoing';
      } else {
        direction = message.sender.type == MessageType.Customer ? 'incoming' : 'outgoing';
      }
    }
  }
  return {
    sid: message.sid,
    username: message.sender.name,
    date: moment(message.dateUpdated).calendar(),
    body: message.body,
    index: message.index,
    deliveryReceipt: message.deliveryReceipt,
    datetime: new Date(message.dateUpdated),
    incoming: direction == 'incoming' ? true : false,
    media: fbMedia,
    direction,
  };
};

export const setMediaFileName = async (medias) => {
  await medias.forEach(async (item, index) => {
    if (!item.state.filename) item.state.filename = item.state.sid + '.' + item.state.contentType.split('/')[1];
  });
  return medias;
};

export const composeConversation = (conv) => {
  return {
    id: conv.id,
    sid: conv.conversationSid,
    friendlyName: conv.friendlyName,
    nickName: conv.nickName || conv.friendlyName,
    uniqueName: conv.uniqueName,
    isOnline: false,
    unread_messages_count: 0,
    lastMessage: conv.lastMessage,
    status: conv.status,
    messages: {
      hasNextPage: true,
      isNextPageLoading: false,
      pageNo: 1,
      pageSize: 10,
      items: [],
      total: 0,
      firstLoaded: false,
      typing: {
        on: false,
        user: '',
      },
    },
    channelType: conv.channelType,
    hasRated: conv.hasRated,
    obtainedRating: conv.rating,
    closedBy: conv.closedBy,
    dateClosed: conv.dateClosed,
    note: conv.note,
    disposition: conv.disposition,
    visitorId: conv.visitorId,
    campaignId: conv.campaignId,
    customerInfo: conv.customerInfo,
    hasDisposition: conv.disposition == null ? false : true,
    conversationType: conv.conversationType,
    webChatHistory: {},
  };
};

export const composeHistory = (history) => {
  return {
    conversationId: history.conversationId,
    conversationSid: history.conversationSid,
    conversationType: history.conversationType,
    dateCreated: history.dateCreated,
    agentInfo: history.agentInfo,
    visitorId: history.visitorId,
    nickName: history.nickName,
    messages: {
      hasNextPage: true,
      isNextPageLoading: false,
      pageNo: 1,
      pageSize: 10,
      items: [],
      total: 0,
      firstLoaded: false,
    },
  };
};

export const playAudio = () => {
  try {
    const audio = new Audio('/mp3/sms.mp3');
    audio.play();
  } catch (e) {}
};

export const getError = (a) => {
  let m = '';
  for (let p in a.errors) {
    m = m + a.errors[p];
  }
  return m;
};
export const toAlphaNumeric = (str) => {
  return str.replace(/[^a-z0-9+ ]/gi, '');
};

/**
 * Get browser details
 *
 * @returns {name, version}
 */
export const getBrowserDetail = () => {
  var ua = navigator.userAgent,
    uad = navigator.userAgentData,
    tem,
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: tem[1] || '' };
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return { name: 'Opera', version: tem[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: M[1],
    OS: uad.platform,
  };
};

export const capitalizeKeys = (obj) => {
  const isObject = (o) => Object.prototype.toString.apply(o) === '[object Object]';
  const isArray = (o) => Object.prototype.toString.apply(o) === '[object Array]';

  let transformedObj = isArray(obj) ? [] : {};

  for (let key in obj) {
    // replace the following with any transform function
    const transformedKey = key.replace(/^\w/, (c, _) => c.toUpperCase());

    if (isObject(obj[key]) || isArray(obj[key])) {
      transformedObj[transformedKey] = capitalizeKeys(obj[key]);
    } else {
      transformedObj[transformedKey] = obj[key];
    }
  }
  return transformedObj;
};

export const downloadImage = async (filename, path) => {
  saveAs(path, filename);
  // function toDataURL(url) {
  //   return fetch(url, { mode: 'no-cors' })
  //     .then((response) => {
  //       return response.blob();
  //     })
  //     .then((blob) => {
  //       return URL.createObjectURL(blob);
  //     });
  // }
  // const a = document.createElement('a');
  // a.href = await toDataURL(path);
  // a.download = filename;
  // document.body.appendChild(a);
  // a.click();
  // document.body.removeChild(a);
};
export const bytesToSize = (bytes) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]})`;
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};
export function getFileTypeIcon(filename) {
  let icon = '';
  if (!filename) return;

  filename = filename.toLowerCase();
  if (filename.match(/\.(jpg|jpeg|png|gif|bmp)$/i)) {
    icon = 'fa fa-file-image fa-fw';
  } else if (filename.match(/\.(zip|rar)$/i)) {
    icon = 'fa fa-file-archive fa-fw';
  } else if (filename.match(/\.(mp3)$/i)) {
    icon = 'fa fa-file-audio fa-fw';
  } else if (filename.match(/\.(mp4|mpv|wmv|avi|avchd|flv|f4v|swf|webm|html5)$/i)) {
    icon = 'fa fa-file-movie fa-fw';
  } else if (filename.match(/\.(doc|docx)$/i)) {
    icon = 'fa fa-file-word fa-fw';
  } else if (filename.match(/\.(txt)$/i)) {
    icon = 'fa fa-file-text fa-fw';
  } else if (filename.match(/\.(xlsx|xlsm|xlsb|xltx)$/i)) {
    icon = 'fa fa-file-excel fa-fw';
  } else if (filename.match(/\.(ppt)$/i)) {
    icon = 'fa fa-file-powerpoint fa-fw';
  } else if (filename.match(/\.(pdf)$/i)) {
    icon = 'fa fa-file-pdf fa-fw';
  } else {
    icon = 'fa fa-file fa-fw';
  }
  return icon;
}

/**
 * @param {Object} obj to cloning
 *
 * @return copiedObj
 */
export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}
